import React from "react";
import "./index.scss";
export const Placeholder = (props) => {
  const left = props.depth * 24;
  return <div className="placeholder" style={{ left }}></div>;
};
